import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center max-w-7xl mx-auto px-4 py-16 text-center">
      <div className="max-w-md p-8 sm:p-10 rounded-2xl bg-white border border-stone-200 shadow-lg space-y-6">
        <div className="w-16 h-16 rounded-2xl bg-amber-50 border border-amber-200 text-amber-700 flex items-center justify-center text-3xl mx-auto">
          <i className="fa-solid fa-triangle-exclamation"></i>
        </div>

        <div className="space-y-2">
          <span className="text-xs font-bold uppercase tracking-widest text-amber-700">Fejl 404</span>
          <h1 className="text-3xl font-extrabold text-stone-900">Siden blev ikke fundet</h1>
          <p className="text-stone-600 text-sm leading-relaxed">
            Siden du leder efter findes desværre ikke eller er flyttet.
          </p>
        </div>

        <div className="pt-2 space-y-3">
          <Link
            to="/"
            className="w-full py-3 px-4 rounded-none bg-stone-900 hover:bg-black text-white font-bold text-sm block transition-colors shadow-md"
          >
            <i className="fa-solid fa-house mr-2"></i> Gå til forsiden
          </Link>

          <Link
            to="/prisberegner"
            className="w-full py-2.5 px-4 rounded-none bg-stone-100 hover:bg-stone-200 text-stone-800 font-bold text-xs block transition-colors border border-stone-300"
          >
            Prøv vores online prisberegner
          </Link>
        </div>
      </div>
    </div>
  );
}
